<template>
  <div class="study-Location">
    <div class="DoT-one1"></div>
    <div class="DoT-two2"></div>
    <div class="Training">
      <p>{{$t('i.search.selfSocialRegulation')}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "rules"
  }
</script>

<style scoped>
  .study-Location{
    position: relative;
  }

  .DoT-one1{
    width: 10px;
    height: 10px;
    position: absolute;
    left: 85px;
    background-color: #e50020;
  }
  .DoT-two2{
    width: 10px;
    height: 10px;
    position: absolute;
    left: 85px;
    top: 20px;
    background-color: #a8a8a9;
  }

  .Training{
    width: 779px;
    height: 32px;
    position: absolute;
    left: 107px;
  }
  .Training p{
    display: inline-block;
  }
  .Training p:nth-child(1){
    font-size: 30px;
    position: absolute;
    top: -8px;
  }

  .Training p:nth-child(2){
    font-size: 20px;
    color: #969696;
    position: absolute;
    top: 5px;
    left: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/search/components/rules.vue